import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { TabNotesService, TabNote } from '../../../services/tab-notes.service';
import {
  compareGlossaryTabOrder,
  tabNoteDisplayLabel,
} from '../../constants/tab-note-display-labels';

@Component({
  selector: 'app-generic-glossary',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
  ],
  templateUrl: './generic-glossary.component.html',
  styleUrl: './generic-glossary.component.scss',
})
export class GenericGlossaryComponent implements OnInit {
  private tabNotesService = inject(TabNotesService);

  loading = true;
  error: string | null = null;
  /** Notes with non-empty content, sorted by display label */
  sections: { note: TabNote; title: string }[] = [];

  ngOnInit(): void {
    this.tabNotesService.getGlossaryTabNotes().subscribe({
      next: (res) => {
        const withContent = (res.notes || []).filter(
          (n) => n.content && n.content.trim().length > 0
        );
        this.sections = withContent
          .map((note) => ({
            note,
            title: tabNoteDisplayLabel(note.tab_name),
          }))
          .sort((a, b) =>
            compareGlossaryTabOrder(a.note.tab_name, b.note.tab_name)
          );
        this.loading = false;
        this.error = null;
      },
      error: (err) => {
        console.error('Glossary: failed to load tab notes', err);
        this.error =
          err?.error?.detail ||
          err?.message ||
          'Could not load glossary notes. Please try again later.';
        this.loading = false;
        this.sections = [];
      },
    });
  }
}
